"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /**
         * Maintains an array of virtualized properties for each control
         */
        var VirtualizedProperties = /** @class */ (function () {
            function VirtualizedProperties() {
                /** @internal */
                this.datasourceMap = {};
                this.propertyStates = {};
            }
            VirtualizedProperties.prototype.setProperty = function (controlName, propertyName, propertyValuesArray, formId) {
                var propertyValues = propertyValuesArray ? propertyValuesArray.slice(0) : [];
                if (controlName) {
                    var controlProperties = this.propertyStates[controlName];
                    if (!controlProperties) {
                        controlProperties = {};
                        controlProperties[propertyName] = propertyValues;
                    }
                    else if (!controlProperties[propertyName]) {
                        controlProperties[propertyName] = propertyValues;
                    }
                    else {
                        for (var i = 0, len = propertyValues.length; i < len; i++) {
                            var currentValue = controlProperties[propertyName][i];
                            if (propertyValues[i] == null) {
                                continue;
                            }
                            if ($dyn.isObservable(currentValue)) {
                                currentValue(propertyValues[i]);
                            }
                            else {
                                controlProperties[propertyName][i] = propertyValues[i];
                            }
                            // when virtualized property for a row is updated , refresh the corresponding model's version
                            // so that grid will rerender the row.
                            if (this.datasourceMap[controlName]) {
                                var modelcollection = $dyn.value(this.datasourceMap[controlName]);
                                if (modelcollection && modelcollection.items()[i] && $dyn.serverForm.ModelManager.modelVersions[formId]) {
                                    var modelMasterTrackingId = modelcollection.items()[i].masterTrackingId;
                                    $dyn.serverForm.ModelManager.modelVersions[formId][modelMasterTrackingId] = $dyn.serverForm.ModelManager.getLastVersion();
                                }
                                else {
                                    $dyn.logWarning("$dyn.serverForm.VirtualizedProperties.setProperty: cannot find corresponding model for virtualized property - control: %s, property: %s, index: %s , formId: %s", controlName, propertyName, i, formId);
                                }
                            }
                        }
                    }
                    this.propertyStates[controlName] = controlProperties;
                    this.getItemsChangedTrigger(controlName, propertyName).raise();
                }
            };
            VirtualizedProperties.prototype.getProperty = function (controlName, propertyName, index, virtualDefaultValue) {
                if (index === undefined || index === null) {
                    index = 0;
                }
                var controlProperties = this.propertyStates[controlName];
                if (!controlProperties) {
                    controlProperties = this.propertyStates[controlName] = {};
                }
                var propertyValues = controlProperties[propertyName];
                if (!propertyValues) {
                    propertyValues = controlProperties[propertyName] = [];
                }
                var currentValue = propertyValues[index];
                // If the value at requested index is undefined, it might mean that the virtualization context is incorrectly setup
                // for the control on the server, log a warning
                if (currentValue === undefined) {
                    if (index < 0) {
                        return virtualDefaultValue;
                    }
                    currentValue = virtualDefaultValue;
                }
                var value = currentValue;
                if (!$dyn.isObservable(currentValue)) {
                    value = propertyValues[index] = $dyn.observable(currentValue);
                }
                return value;
            };
            VirtualizedProperties.prototype.getItemsChangedTrigger = function (controlName, propertyName) {
                var controlProperties = this.propertyStates[controlName];
                if (controlProperties && controlProperties[propertyName]) {
                    var propertyValuesCollection = controlProperties[propertyName];
                    if (!propertyValuesCollection._itemsChanged) {
                        propertyValuesCollection._itemsChanged = new $dyn.eventHost();
                    }
                    return propertyValuesCollection._itemsChanged;
                }
            };
            return VirtualizedProperties;
        }());
        serverForm.VirtualizedProperties = VirtualizedProperties;
        function getVirtualValue(controlName, propertyName, parentDataSource, rootElement) {
            var map = rootElement.dynVirtualizedProperties;
            var virtualProperty = $dyn.computed(function () {
                var collectionIndex = 0;
                var currentitem = $dyn.value(parentDataSource);
                if (currentitem) {
                    collectionIndex = $dyn.value(currentitem.collectionIndex);
                }
                var property = map.getProperty(controlName, propertyName, collectionIndex);
                return $dyn.peek(property);
            });
            $dyn.serverForm.subscribeToVirtualizedPropertyChange(controlName, propertyName, rootElement, function () {
                virtualProperty.valueChanged.raise();
            });
            return virtualProperty;
        }
        serverForm.getVirtualValue = getVirtualValue;
        function subscribeToVirtualizedPropertyChange(controlName, propertyName, rootElement, callback) {
            var map = rootElement.dynVirtualizedProperties;
            var itemsChangedTrigger = map.getItemsChangedTrigger(controlName, propertyName);
            itemsChangedTrigger.subscribe(callback);
        }
        serverForm.subscribeToVirtualizedPropertyChange = subscribeToVirtualizedPropertyChange;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=VirtualizedProperties.js.map
